// src/types/index.ts
function isFeedbackCategory(value) {
  return typeof value === "string" && ["bug", "feature", "other"].includes(value);
}
function isRating(value) {
  return typeof value === "string" && ["angry", "neutral", "happy"].includes(value);
}

// src/constants/index.ts
var FEEDBACK_CATEGORIES = [
  { value: "bug", label: { en: "Bug", "zh-CN": "\u95EE\u9898\u53CD\u9988" } },
  { value: "feature", label: { en: "Feature", "zh-CN": "\u529F\u80FD\u5EFA\u8BAE" } },
  { value: "other", label: { en: "Other", "zh-CN": "\u5176\u4ED6" } }
];
var APP_IDS = [
  { value: "json-toolkit", label: { en: "JSON Toolkit", "zh-CN": "JSON \u5DE5\u5177\u7BB1" } }
];
var SUPPORTED_LANGUAGES = ["en", "zh-CN"];
var DEFAULT_LANGUAGE = "en";
var IMAGE_UPLOAD_LIMIT = {
  maxSize: 5 * 1024 * 1024,
  maxCount: 3,
  allowedTypes: ["image/jpeg", "image/png", "image/webp", "image/gif"]
};
var RATE_LIMIT_PER_DAY = 3;

// src/schemas/feedback.schema.ts
import { z } from "zod";
var FeedbackCategorySchema = z.enum(["bug", "feature", "other"], {
  message: "form.category.required"
});
var AppIdSchema = z.enum(["json-toolkit"], {
  message: "form.appId.required"
});
var RatingSchema = z.enum(["angry", "neutral", "happy"]);
var FeedbackSchema = z.object({
  description: z.string().min(10, "form.description.min").max(1200, "form.description.max"),
  category: FeedbackCategorySchema,
  appId: AppIdSchema,
  rating: RatingSchema.optional(),
  userEmail: z.string().email("form.userEmail.invalid").optional().or(z.literal("")),
  userName: z.string().optional().or(z.literal(""))
});
var ImageUploadSchema = z.object({
  images: z.array(z.instanceof(File)).max(IMAGE_UPLOAD_LIMIT.maxCount, "images.max_count").optional()
});

// src/keys/index.ts
function buildFeedbackKey(appId, id) {
  return `feedback:${appId}:${id}`;
}
function parseFeedbackKey(key) {
  const parts = key.split(":");
  if (parts.length !== 3 || parts[0] !== "feedback") {
    return null;
  }
  return { appId: parts[1], id: parts[2] };
}
var KV_KEY_PREFIX = "feedback:";
export {
  APP_IDS,
  AppIdSchema,
  DEFAULT_LANGUAGE,
  FEEDBACK_CATEGORIES,
  FeedbackCategorySchema,
  FeedbackSchema,
  IMAGE_UPLOAD_LIMIT,
  ImageUploadSchema,
  KV_KEY_PREFIX,
  RATE_LIMIT_PER_DAY,
  RatingSchema,
  SUPPORTED_LANGUAGES,
  buildFeedbackKey,
  isFeedbackCategory,
  isRating,
  parseFeedbackKey
};
